/**
 * 检查当前环境是否支持某个 api
 */
export function checkJsApi(params) {
    return params
        .api(Object.assign({ _checkMode: true }, params))
        .then((res) => {
        const finalRes = res;
        finalRes.result = !res.error;
        return finalRes;
    });
}
export { checkBridgeVersion } from './utils/config.mjs';
